import { PureComponent } from 'react'

import { Block, Label, FieldMessage, VehicleLoadsList } from '@/forms-legacy'

import RestoreFieldButton from '../primitives/RestoreFieldButton'

import { Props } from './typings'

export default class LoadsField extends PureComponent<Props> {
  render() {
    const {
      label,
      name,
      info,
      half = false,
      wrappedInputProps,
      testid,
      formProps: {
        input: { value, onChange },
        meta: { error, dirty, initial },
      },
    } = this.props

    return (
      <Block half={half} error={!!error} dirty={!!dirty} data-testid={testid} data-trackid={testid}>
        <Label htmlFor={name}>
          {label}{' '}
          <RestoreFieldButton
            dirty={dirty}
            initial={initial}
            onChange={onChange}
            style={{ marginLeft: 12 }}
          />
        </Label>
        <VehicleLoadsList {...wrappedInputProps} onChange={onChange} value={value} />
        {!!error && <FieldMessage error>{error}</FieldMessage>}
        {!!info && <FieldMessage>{info}</FieldMessage>}
      </Block>
    )
  }
}
